"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

exports.__esModule = true;
exports.parse = void 0;

var papaparse_1 = require("papaparse");

exports.parse = function (file, config) {
  return new Promise(function (complete, error) {
    papaparse_1.parse(file, __assign(__assign({}, config), {
      complete: complete,
      error: error
    }));
  });
};